import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../redux";
import { PartnerProgramData } from "../../types";

interface PartnerProgramCardProps {
  data: PartnerProgramData;
  partnerId: number;
}

const RING_RADIUS = 54;

const PartnerProgramCard: React.FC<PartnerProgramCardProps> = ({
  data,
  partnerId,
}) => {
  const navigate = useNavigate();
  const { partnerDetails } = useAppSelector((state) => state.partner_details);

  const circumference = 2 * Math.PI * RING_RADIUS;
  const strokeDashoffset =
    circumference - (data.progressPercent / 100) * circumference;

  const handleNavigate = () => {
    navigate(`/partner/${partnerId}/dashboard/partner-program`);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleNavigate();
    }
  };

  return (
    <div
      className="partner-program-card partner-program-card--clickable"
      role="button"
      tabIndex={0}
      onClick={handleNavigate}
      onKeyDown={handleKeyDown}
    >
      <div className="partner-program-card__header">
        <h3 className="partner-program-card__title">Partner Program</h3>
        <p className="partner-program-card__subtitle">
          {partnerDetails?.partner_name ?? "—"}
        </p>
      </div>

      <div className="partner-program-card__tier">
        <div className="partner-program-card__tier-main">
          <span className="partner-program-card__tier-value">{data.tier}</span>
          {/* Top 15% badge hidden until API provides percentile data */}
          {/* <span className="partner-program-card__tier-badge">Top 15%</span> */}
        </div>
        <span className="partner-program-card__tier-label">Current Tier</span>
      </div>

      <div className="partner-program-card__chart" aria-hidden>
        <svg viewBox="0 0 140 140" className="partner-program-card__ring-svg">
          <circle
            className="partner-program-card__ring-track"
            cx="70"
            cy="70"
            r={RING_RADIUS}
          />
          <circle
            className="partner-program-card__ring-progress"
            cx="70"
            cy="70"
            r={RING_RADIUS}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
          />
        </svg>
      </div>

      <div className="partner-program-card__footer">
        <span className="partner-program-card__points">
          {data.currentPoints.toLocaleString("en-US")} /{" "}
          {data.nextTierPoints.toLocaleString("en-US")} pts
        </span>
      </div>
    </div>
  );
};

export default PartnerProgramCard;
